import * as React from "react";
import { useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import { FxInfoList } from "../../fxms/components/FxInfoList";
import { FxRenderer } from "../../fxms/datas/FxRenderer";

/**
 * 정비계획을 나타내는 컴포넌트.
 * 개발자 : 김종훈.
 * 개발년월 : 2022.11.
 * @returns 
 */
export const FeInfoFacMntnList = (props) => {

  const { onClick } = props;
  const [inform, setInform] = useState(null);


  useEffect(() => {
    const list = getNoticeData();
  }, []);

  async function getNoticeData() {
    const uri = "fems/select_fe_fac_mntn";
    const para = { limit: 3 };
    const ret = [];
    const res = await FxmsData.GET(uri, para);
    const inform = [];
    let index = 0;
    for (let data of res.data) {
      inform.push({ id: data.mntnNo, title: data.mntnTitle, date: FxRenderer.renderDate(data.mntnResvDate) });
    }
    setInform(inform);
  }

  return <FxInfoList title='정비계획' inform={inform} onClick={props.onClick} moreOpId="ui-3-2" itemOpId="ui-3-2-show">
  </FxInfoList>
};
